<template>
  <g>
    <g class="y-axis" v-for="(tick, tickIndex) in p.ticksY" :key="tickIndex">
      <line
        :x1="0"
        :x2="c.yAxisWidth"
        :y1="p.scaleY(tick)"
        :y2="p.scaleY(tick)"
        :style="{ stroke: c.yAxisTickStrokeColor, 'stroke-width': 1 }"
      ></line>
      <text
        class="label"
        :x="
          (c.yAxisPosition === 'left' ? p.left : p.width - p.right) +
          +c.yAxisLabelXOffset
        "
        :y="p.scaleY(tick) + c.yAxisLabelYOffset"
        :key="tickIndex"
        :fontSize="c.yAxisFontSize"
        :transform="
          c.yAxisTranslate &&
          `translate(${c.yAxisTranslate.x}, ${c.yAxisTranslate.y})`
        "
        :style="{
          fontSize: +c.yAxisFontSize,
          textAnchor: c.yAxisLabelAnchor,
          width: '60px',
          fill: 'white',
        }"
        >{{ $n(+p.format(tick)) }}{{ c.globalUnitSymbol }}</text
      >
    </g>
  </g>
</template>

<script>
export default {
  props: ["p", "c"],
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.y-axis {
  .label {
    @include dida-S;
  }
}
</style>
